// Converted from application/views/sculptures/mother&child-marble_v.php. Edit this component directly.
export default function SculpturesMotherChildMarblePage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-cover.jpg"} alt={"Mother & Child at Museo degli Innocenti, Florence"} />
<figcaption>{"Mother & Child at Museo degli Innocenti, Florence"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Mother & Child"}</h1>
<h2>{"\n                    In Carrara Marble\n                "}</h2>
<p>
<b>{"97 x 97 x 100 cm"}</b><br />{"\n                    38” x 38” x 39”"}<br />{"\n                    Carrara Marble"}<br />{"\n                    No. in Series 6\n                "}</p>
<p class={"calltoaction"}><a href={"/c/sculpture/mother&child-story"}>
<img src={"/icons/book.svg"} alt={"read the story"} class={"iconBook"} />{"\n                        Read the story"}</a></p>
</div>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-frassinoro.jpg"} alt={"Finshed Mother & Child in Frassinoro"} />
<figcaption>{"Finshed Mother & Child in Frassinoro"}</figcaption>
</figure>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                The original sculpture in wax was made at Paddy Campbell’s studio at Fairview, Dublin, in 2005.  It was cast in bronze and exhibited in many venues, in Ireland, UK,Greece,  and Italy, before being carved in Cararra marble in 2015.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-pietrasanta.jpg"} alt={"Mother & Child in Pietrasanta"} />
<figcaption>{"Mother & Child in Pietrasanta"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-baby-feet-closeup.jpg"} alt={"The Baby's feet"} />
<figcaption>{"The Baby's feet"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                The mother, Emily, and her daughter Coco now live in Margate in the South of England, and take a keen interest in how the sculpture is doing.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                The Cararra marble version (unique) has found a permanent home at the “Museo degli Innocenti” in Piazza Santissima Annunciata, Florence.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-baby-closeup.jpg"} alt={"The Baby"} />
<figcaption>{"The Baby"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-pietrasanta2.jpg"} alt={"Mother & Child in Pietrasanta"} />
<figcaption>{"Mother & Child in Pietrasanta"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<div class={"text"}>
<div style={{"flexDirection":"column","justifyContent":"center","maxWidth":"80%","height":"20rem","display":"flex","alignItems":"center"}}>
<blockquote style={{"textAlign":"center"}}>{"“The time I spent making Mother and Child with Emily and Coco was as near as a man can get to motherhood”"}</blockquote>
<p>{"Paddy Campbell, March 2005"}</p>
</div>
</div>
</div>
</>;
}
